var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f35325",
    d: "M0 0h10v10H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#81bc06",
    d: "M11 0h10v10H11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#05a6f0",
    d: "M0 11h10v10H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffba08",
    d: "M11 11h10v10H11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/MicrosoftIcon.db4d2aeda8ab5755a11c2c28dc88aade.svg";
export { ForwardRef as ReactComponent };